export class Reports {

}
